/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Sales_Campaign_Name_TakenInputs */

const en_error_sales_campaign_name_taken = /** @type {(inputs: Error_Sales_Campaign_Name_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Another campaign already has this name.`)
};

/**
* | output |
* | --- |
* | "Another campaign already has this name." |
*
* @param {Error_Sales_Campaign_Name_TakenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_sales_campaign_name_taken = /** @type {((inputs?: Error_Sales_Campaign_Name_TakenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Sales_Campaign_Name_TakenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_sales_campaign_name_taken(inputs)
});